export const workflowActionData = {
  mf_name: 'Fund 10288',
  long_value:
    'A text field with a very long value that is very long, containing a lot of unnecessary words just to make it artificially long.',
  amount: 18_000.234,
  currency: 'EUR',
  due_date: new Date().toISOString(),
  requiredText: null,
  optionalText: null,
  integerValue: null,
  requiredInteger: null,
  numberValue: null,
  requiredDate: null,
  optionalDate: null,
  optionalBoolean: null,
  nested_values: {
    nested_name: 'John Doe',
    nested_number: 42,
  },
};
